// ** UI
import Typography from '@mui/material/Typography';
import Button, { type ButtonProps } from '@mui/material/Button';
import CircularProgress, { type CircularProgressProps } from '@mui/material/CircularProgress';
import { styled } from '@mui/material/styles';

// ** Types
import type React from 'react';

export type CustomButtonType = ButtonProps & {
	size?: 'medium' | 'large' | 'small';
	type?: 'button' | 'submit' | 'reset';
	loading?: boolean;
	successful?: boolean;
	successfulLabel?: string;
	disabled?: boolean;
	children?: React.ReactNode;
};

type CustomCircularProgress = CircularProgressProps & {
	small?: boolean;
};

// ** Styled Components
const MuiCircularProgress = styled(CircularProgress, {
	shouldForwardProp: (prop) => prop !== 'containerClass'
})<CustomCircularProgress>(({ small }) => ({
	position: 'absolute',
	top: small ? 'calc(50% - 7.5px)' : 'calc(50% - 13.5px)',
	left: small ? 'calc(50% - 7.5px)' : 'calc(50% - 13.5px)'
}));

const CustomButton = ({
	size,
	type,
	loading = false,
	successful = false,
	successfulLabel = 'Successful',
	disabled = false,
	children,
	...other
}: CustomButtonType) => {
	const small = size === 'small';

	return (
		<Button
			type={type}
			disabled={loading || disabled}
			size={size}
			// classes={{
			//     label: small ?
			//         customClass ?
			//             clsx(classes.smallHeight, customClass) : classes.smallHeight
			//         :
			//         customClass ?
			//             clsx(classes.normalHeight, customClass) : classes.normalHeight
			// }}
			{...other}
		>
			<Typography
				component="span"
				sx={{
					display: 'flex',
					alignItems: 'center'
				}}
			>
				{!loading && (successful ? successfulLabel : children)}

				{loading && (
					<MuiCircularProgress
						size={small ? 15 : 27}
						color="inherit"
						// small={small}
						// className={small ? classes.spinnerSmall : classes.spinner}
					/>
				)}
			</Typography>
		</Button>
	);
};

export default CustomButton;
